import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-amplitudeimage',
  templateUrl: './amplitudeImage.component.html',
  styleUrls: ['../IconDesings.scss'],
})

export class AmplitudeImageComponent {
  constructor() {
  }
}